import { Node } from '@tiptap/core';

export const YouTube = Node.create({
  name: 'youtube',

  group: 'block',

  atom: true,

  addAttributes() {
    return {
      src: {
        default: null,
      },
      width: {
        default: '100%',
      },
      height: {
        default: 400,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: 'iframe[src*="youtube"]',
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'div',
      { class: 'youtube-container', style: 'margin: 16px 0;' },
      [
        'iframe',
        {
          ...HTMLAttributes,
          width: HTMLAttributes.width || '100%',
          height: HTMLAttributes.height || 400,
          frameborder: '0',
          allow: 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture',
          allowfullscreen: 'allowfullscreen',
          style: 'border-radius: 4px; display: block;',
        },
      ],
    ];
  },

  // @ts-ignore - Type inference issue with custom commands
  addCommands() {
    return {
      setYoutubeVideo:
        (options: { src: string; width?: string; height?: number }) =>
        ({ commands }: any) => {
          return commands.insertContent({
            type: this.name,
            attrs: options,
          });
        },
    };
  },
});
